import React from 'react';
import { getContactData } from '../utils/contactData';

/**
 * Reusable wrapper component for legal pages (Terms, Privacy, etc.)
 * Provides consistent structure and styling for legal content
 *
 * @param {string} title - Page title (e.g., "Privacy Policy")
 * @param {string} lastUpdated - Last update date
 * @param {string|ReactNode} intro - Introduction text
 * @param {ReactNode} children - Main content sections
 * @param {string} footerText - Acknowledgement text in footer
 */
const LegalPage = ({ title, lastUpdated, intro, children, footerText }) => {
  return (
    <div className="legal-page">
      <div className="container">
        <h1>{title}</h1>
        <p className="legal-intro">
          <strong>Last Updated:</strong> {lastUpdated}
        </p>
        {intro && <p className="legal-intro">{intro}</p>}

        <div className="legal-content">{children}</div>

        <div className="legal-footer">
          <p>{footerText}</p>
          <a href="/contact" className="btn btn-primary">
            Contact Us
          </a>
        </div>
      </div>
    </div>
  );
};

/**
 * Reusable section component for legal content
 */
export const LegalSection = ({ title, children }) => (
  <section className="legal-section">
    <h2>{title}</h2>
    {children}
  </section>
);

/**
 * Contact information component for legal pages
 */
export const LegalContactInfo = () => {
  const contactData = getContactData();

  return (
    <ul>
      <li>
        <strong>Email:</strong> {contactData.email}
      </li>
      <li>
        <strong>Phone:</strong> {contactData.phone}
      </li>
      <li>
        <strong>Address:</strong> {contactData.address}
      </li>
    </ul>
  );
};

export default LegalPage;
